/* @jsx h */
import { defineComponent, h } from "vue";
import { CustomerCheckout } from "@lemmonhq/types";
import { SubmittedOrderCard } from "./SubmittedOrderCard";
import { useMenu } from "@app/vue/providers/index";
import { computed } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export interface SubmittedOrdersListProps {}

export const SubmittedCheckoutsList = defineComponent<SubmittedOrdersListProps>(
  {
    name: "SubmittedOrdersList",
    props: [],
    setup(props) {
      const { groupOrder } = useMenu();
      const { t } = useLocalization();
      const confirmedCheckouts = computed(() => {
        return groupOrder.value?.checkouts.filter(
          (el) => el.status === "confirmed",
        );
      });
      return () => {
        if (!confirmedCheckouts.value) {
          return null;
        }
        return (
          <div class="space-y-4">
            {confirmedCheckouts.value.length === 0 ? (
              <div class="rounded bg-base-200 shadow-lg hover:shadow-xl ">
                <div class=" text-center py-12">
                  <div class="text-6xl mb-4 opacity-50">📋</div>
                  <h3 class="text-lg font-semibold mb-2 text-base-content/70">
                    {t("customer.checkout_status.no_orders_submitted")}
                  </h3>
                  <p class="text-base-content/50">
                    {t("customer.checkout_status.orders_appear_here")}
                  </p>
                </div>
              </div>
            ) : (
              <div class="space-y-4">
                {confirmedCheckouts.value.map((checkout) => (
                  <SubmittedOrderCard key={checkout.id} checkout={checkout} />
                ))}
              </div>
            )}
          </div>
        );
      };
    },
  },
);
